import { useAsync } from '@sit/client-shared';
import { useTokenFragment } from '../auth/use-token-fragment';
import { invalidateIdb } from '../helpers/invalidate-idb';

export function useCacheBustIndexDbIfDifferentUser(): {
  data: void | null;
  loading: boolean;
  error: Error | null;
} {
  const token = useTokenFragment();
  return useAsync(() => invalidateIdb(token), [token]);
}
